import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

// 컨텐츠 선생님 목록 가져오기
export const get_content_teacher_list = () => {
    console.log("api get content teacher list:)");

    return axiosClient.get(`/content/teacher`, options);
}

// 로그인 가능한 클래스 목록 가져오기
export const get_loginable_live_list = () => {
    console.log("api get loginable live list:)");

    return axiosClient.get(`/content/live`, options);
}